/**
 * E2E Attributes
 *
 * Please note that any changes of the provided e2e attributes names should
 * be discussed and agreed with the QA automation team
 */

export enum E2E_ATTRIBUTES {
  ALERT_MODAL = 'alert-modal',
  ALERT_MODAL_FOOTER_BUTTON_CLOSE = 'alert-modal-footer-button-close',
  BREAK_DROPDOWN_SELECTED_ITEM_BUTTON = 'break-dropdown-selected-item-button',
  BREAK_DROPDOWN_SELECTED_ITEM_TITLE = 'break-dropdown-selected-item-title',
  CONFIRM_BUTTONS_CANCEL = 'confirm-btn-reset',
  CONFIRM_BUTTONS_ENTER = 'confirm-btn-enter',
  CONFIRM_BUTTONS_OPTIONAL = 'confirm-btn-optional',
  CONFIRM_COMPONENT = 'confirm-component',
  CONFIRM_COMPONENT_MODAL_FOOTER_BUTTON_CANCEL = 'confirm-component-modal-footer-button-cancel',
  CONFIRM_COMPONENT_MODAL_FOOTER_BUTTON_CONFIRM = 'confirm-component-modal-footer-button-confirm',
  DM_GRID = 'dm-grid',
  INPUT_COMPONENT_INPUT_ELEMENT = 'input-component-input-element',
  KEY_PAD = 'key-pad',
  KEY_PAD_CONTAINER = 'key-pad-container',
  KEY_PAD_DISPLAY = 'key-pad-display',
  KEY_PAD_BUTTON_TEXT = 'key-pad-button-text',
  KEY_PAD_BUTTON_VALUE = 'key-pad-button-value',
  KEY_PAD_INPUT = 'key-pad-input',
  KEY_PAD_INPUT_ELEMENT = 'key-pad-input-element',
  KEY_PAD_INPUT_VIEW_PLACEHOLDER = 'key-pad-input-view-placeholder',
  KEY_PAD_INPUT_PLACEHOLDER_USER_KP_TYPE = 'key-pad-input-placeholder-user-kpType',
  LOADER_COMPONENT = 'loader-component',
  LOYALTY_CUSTOMER_HEADER_DROPDOWN = 'loyalty-customer-profile-header-dropdown',
  LOYALTY_CUSTOMER_HEADER_DROPDOWN_TITLE = 'loyalty-customer-profile-header-dropdown-title',
  MAIN_CONTEXT = 'main-context',
  MODAL_CONTAINER = 'modal-container',
  MODAL_CONTENT = 'modal-content',
  MODAL_FOOTER = 'modal-footer',
  MODAL = 'modal',
  ORDER_HISTORY_RECORD = 'order-history-record',
  ORDER_HISTORY_RECORD_COLUMN = 'order-history-record-column',
  ITEM_COUNT_PAGE = 'item-count-page',
  REQUEST_TRANSFER_PAGE = 'request-transfer-page',
  REQUEST_TRANSFER_PAGE_EDIT = 'request-transfer-page-edit',
  REQUEST_TRANSFER_PAGE_VIEW = 'request-transfer-page-view',
  SEARCH_BOX = 'search-box',
  SEARCH_FIELD = 'search-field',
  SIGN_IN = 'sign-in',
  TOGGLE_BREAK_DROPDOWN_OPTIONS_BUTTON = 'toggle-break-dropdown-options-button',
  TOAST_CONTAINER = 'toast-container',
  TOAST_NOTIFICATION = 'toast-notification',
  TOAST_NOTIFICATION_ICON_CANCEL = 'toast-notification-icon-cancel',
  KEY_PAD_ICON_CLOSE = 'key-pad-icon-close',
  FILTER_PANEL_TOGGLE_BUTTON = 'filter-panel-toggle-button',
  FILTER_PANEL_OPTIONS = 'filter-panel-options',
  FILTER_SETTINGS = 'filter-settings',
  FILTER_PANEL_RESET_BUTTON = 'filter-panel-reset-button',
  FILTER_PANEL_RESET_ALL_BUTTON = 'filter-panel-reset-all-button',
  CHECKBOX_CONTROL = 'checkbox-control',
  CLEAR_ITEM_COUNT_BUTTON = 'clear-item-count-button',
  ADD_ITEM_COUNT_BUTTON = 'add-item-count-button',
}
